export const APPLY_COUPON_REQUEST = 'APPLY_COUPON_REQUEST'
export const APPLY_COUPON_SUCCESS = 'APPLY_COUPON_SUCCESS'
export const APPLY_COUPON_FALIURE = 'APPLY_COUPON_FALIURE'
